export const API_CALLS = {
  GET_AGENCIES: 'getAgencies',
  GET_AGENTS: 'getAgents',
  GET_CONFIG: 'getConfig',
  GET_STUDENT_RECORD: 'getStudentRecord',
  GET_COURSES: 'getCourses',
  GET_USERS: 'getUsers',
  GET_USERS_STUDENTS: 'getStudentUsers',
  GET_USERS_UNI: 'getUniUsers',
  GET_USERS_AGENTS: 'getAgentUsers',
  GET_USERS_ADMIN: 'getAdminUsers',
  GET_USERS_PARTNER: 'getPartnerUsers',
  GET_ALL_REGION_CONFIGS: 'getAllRegionConfigs',
  TOGGLE_USER: 'toggleUser',
  GET_SPECIAL_MAPS: 'getSpecialMaps',
  DELETE_SPECIAL_MAP: 'deleteSpecialMap',
  CLONE_SPECIAL_MAP: 'cloneSpecialMap',
};

export const ALLOWED_FILE_TYPES = ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'pdf'];

export const MATCH_FILTER_NAMES = {
  TAGS_MATCH: 'tagsMatch',
  PROGRAMMABLE_TAGS_MATCH: 'programmableTagsMatch',
};
